// A valid SVG viewBox is four numbers (min-x, min-y, width, height), separated by whitespace
// and/or commas.
const VALID_VIEWBOX = /^\s*[-+]?[\d.]+(?:[\s,]+[-+]?[\d.]+){3}\s*$/;

// Admin-entered icon SVGs (portal links, groups, quick links) occasionally carry a malformed
// viewBox, which the browser reports as a noisy console parse error even though the icon still
// renders. A malformed viewBox is already ignored by the renderer, so stripping it changes
// nothing visually — it only removes the error. Valid viewBoxes are left untouched.
export function sanitizeSvgViewBox(svg: string): string {
	if (!svg) {
		return svg;
	}
	return svg.replace(/\sviewBox\s*=\s*(["'])([\s\S]*?)\1/gi, (match, _quote, value) => (VALID_VIEWBOX.test(value) ? match : ''));
}
